import { Component, Input, OnDestroy } from '@angular/core';
import { ModalService, SimpleMessageService, Tenant, WebAppCommonModule } from '@allbesmart/web-app-common';
import { Subscription } from 'rxjs';
import { TenantManagementService } from "../../services/tenant-management.service";
import { DeploymentDetailsComponent } from '../deployment-details/deployment-details.component';

@Component({
    selector: 'oaibox-delete-deployment-warning-modal',
    templateUrl: './delete-deployment-warning-modal.component.html',
    styleUrls: ['./delete-deployment-warning-modal.component.css'],
    imports: [WebAppCommonModule, DeploymentDetailsComponent],
})
export class DeleteDeploymentWarningModalComponent implements OnDestroy {

  @Input({ required: true }) public tenant!: Tenant;

  private deleteDeploymentSubscription?: Subscription;

  constructor(
    private tenantManagementService: TenantManagementService,
    private simpleMessageService: SimpleMessageService,
    private modalService: ModalService) {
  }

  protected deleteClient(): void {
    this.deleteDeploymentSubscription = this.tenantManagementService.deleteTenant(this.tenant?.id)
      .subscribe({
        next: () => {
          this.simpleMessageService.showSimpleMessage({
            message: 'Deployment deleted successfully!',
            icon: 'fa-solid fa-check-double',
            color: 'success',
          });
          this.tenantManagementService.refreshTenants();
          this.modalService.popModal();
        },
        error: () => {
          this.simpleMessageService.showSimpleMessage({
            message: 'Failed to delete deployment!',
            icon: 'fa-solid fa-triangle-exclamation',
            color: 'danger',
          });
          this.modalService.popModal();
        },
      });
  }

  protected cancel(): void {
    this.modalService.popModal();
  }

  ngOnDestroy(): void {
    this.deleteDeploymentSubscription?.unsubscribe();
  }
}
